(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main_login"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const modal = document.getElementById('forgot-password-modal');
    if (!modal || typeof modal.showModal !== 'function') return;

    const trigger = document.getElementById('forgot-password-trigger');
    const emailInput = document.getElementById('RecoverEmail');
    const successMessage = document.getElementById('recover-success');

    function openModal() {
      modal.showModal();
      emailInput.focus();
    }

    // Escape, returning focus to whatever opened it, and holding focus
    // inside while it is open are the dialog element's own doing.
    function closeModal() {
      modal.close();
      emailInput.value = '';
      successMessage.classList.add('hidden');
    }

    if (trigger) trigger.addEventListener('click', openModal);
    document.getElementById('close-modal').addEventListener('click', closeModal);
    document.getElementById('cancel-modal').addEventListener('click', closeModal);

    // The backdrop is the dialog itself, so a click that landed on no child
    // of the panel is a click outside it.
    modal.addEventListener('click', (event) => {
      if (!event.target.closest('[data-reset-body]')) closeModal();
    });

    // Shopify sends the customer back here with ?recover=success after the
    // reset email goes out, which is the only signal that it worked.
    if (new URLSearchParams(window.location.search).get('recover') === 'success') {
      openModal();
      successMessage.classList.remove('hidden');
    }
  });

  } catch(e) { console.error(e); }
})();
})();
